module.exports = __webpack_public_path__ + "logo_fedex-e61017bbda4c8c8f5e90fce3ccd3bcbb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_fedex.png
// module id = 1376
// module chunks = 1